export default __webpack_public_path__ + "static/media/Hair_7_M_C5.e98a83b4.svg";